<template>
  <router-view></router-view>
</template>

<script>
export default {
  components: {},

  created() {}
};
</script>

<style lang="scss" scoped>
@import '@/style/devices.scss';
.auth-container {
  height: 100vh;
  position: relative;
}

.footer-fixed {
  position: absolute;
  bottom: 0;
  height: 50px;
}

@include mobile {
  .footer-fixed {
    position: unset !important;
    bottom: 0;
    height: 50px;
  }
}
</style>
